document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.id-menu-toggle');
  const nav = document.querySelector('.id-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});